import styled from 'styled-components';

export const QuestionWrapper = styled.div`
  padding-top: 8px;

  & .question-header {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    margin-bottom: 24px;
  }

  & .question {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #1d201f;
  }

  & .description {
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #1d201f;
  }

  & .several {
    font-size: 14px;
    line-height: 16px;
    color: #5b5b5b;
  }

  & .answers {
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
    margin: 0 0 24px 0;
    row-gap: 10px;
  }

  & .img-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const AnswerPopupWrapper = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #1d201f;
  margin-bottom: 20px;
  margin-top: 26px;
`;
